import M_DOM_TOOL from '../dom_tool/index.js'
import M_BASE_TOOL from '../base_tool/index.js'

// 基础数据处理
const handleBase = (main, params) => {
    return M_BASE_TOOL.handleSingleData(params)
}
// pv数据处理
const handlePV = (main, params) => {
    return params
}
// leave数据处理
const handleLeave = (main, params) => {
    return params
}
// 页面停留数据处理
const handleStay = (main, params) => {
    return params
}
// dom节点数据处理
const handleDom = (main, params) => {
    return M_DOM_TOOL.handle(params) 
}

export default {
    handleBase,
    handlePV,
    handleLeave,
    handleStay,
    handleDom
}